// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { Closer } from '@ta/overlays.managers';
import clipboard from '@ta/common.clipboard';
import ListItem from './ListItem';
import type { ListSize } from './ListItem';

type Props = {
  url: string,
  size: ListSize,
};

type State = {
  copied: boolean,
};

class ShareViaClipboard extends React.Component<Props, State> {
  state = {
    copied: false,
  };

  copyAndClose = (url: string, close: () => void) => {
    const successful = clipboard.copy(url);

    if (successful) {
      this.setState({ copied: true });
      // Close the modal after 3 seconds
      setTimeout(() => close(), 3000);
    }

    return successful;
  };

  render() {
    return (
      <Closer>
        {close => (
          <ListItem
            iconName="link"
            size={this.props.size}
            localizedText={
              this.state.copied
                ? localize('link_share_link_copied')
                : localize('link_share_option_clipboard')
            }
            onClickFunction={
              this.state.copied ? undefined : () => this.copyAndClose(this.props.url, close)
            }
          />
        )}
      </Closer>
    );
  }
}

export default ShareViaClipboard;
